export enum ProcedureCodeType {
  CPT = 'CPT',
  HCPCS = 'HCPCS',
}

export enum FilterType {
  INPUT = 'input',
  DATE_RANGE = 'date_range',
  MULTIPLE = 'multiple',
  SINGLE = 'single',
  GROUP = 'group',
  MULTISELECT_INPUT = 'multiselect-input',
}

export enum FilterNames {
  DOS_RANGE = 'date_of_service_range',
  LINE_DOS_START = 'line_date_of_service_start',
  LINE_DOS_END = 'line_date_of_service_end',
  SORT_BY = 'sort_by',
  LOB = 'lob',
  START_DATE = 'start_date',
  END_DATE = 'end_date',
}

export enum AppConfigKeys {
  featureAggregatePolicies = 'feature_aggregate_policies',
  featureChatRip = 'feature_chat_rip',
  featureClaimIDRedirect = 'feature_claim_id_redirect',
  featurePeriodicRefresh = 'feature_periodic_refresh',
  maintenance = 'maintenance',
  featureConfigCopy = 'feature_config_copy',
  featureClaimChain = 'feature_claim_chain',
  featureExclusionClaimLabV2 = 'feature_exclusions_claim_lab_v2',
}

export enum ClaimLineStatus {
  EXCLUDED = 'excluded',
  NOT_PAYABLE = 'not_payable',
  NO_INSIGHTS = 'no_insights',
  NEW_LINE = 'new_line',
  OBSERVATION = 'observation',
  RESOLVED = 'resolved',
  INFLUENCING = 'influencing',
  NOT_INFLUENCING = 'not_influencing',
}

export enum ClaimType {
  Professional = 'Professional',
  ASCProfessional = 'ASC billed on professional form',
  ASCInstitutional = 'ASC billed on institutional form',
  Outpatient = 'Institutional outpatient',
  Inpatient = 'Institutional inpatient',
  NoClaimTypes = 'No claim types',
  AllClaimTypes = 'Any claim type',
}

export enum ClaimTypeShort {
  Professional = 'Professional',
  ASCProfessional = 'ASC on professional',
  ASCInstitutional = 'ASC on institutional',
  Outpatient = 'Outpatient',
  Inpatient = 'Inpatient',
}

export enum ClaimTypeHiro {
  Professional = 'professional',
  ASCProfessional = 'asc_professional',
  ASCInstitutional = 'asc_institutional',
  Outpatient = 'outpatient',
  Inpatient = 'inpatient',
}

export const ClaimTypeValues = Object.values(ClaimType)

export enum HistoryType {
  Off = 'Off',
  Days = 'Lookback days',
  Infinite = 'Infinite',
}
export const HistoryTypeValues = Object.values(HistoryType)
